;(function () {
  'use strict'

  angular
    .module('contrast.time-series')
    .directive('csTimeSeriesTooltip', ['$compile', csTimeSeriesTooltip])

  function csTimeSeriesTooltip($compile) {
    return {
      restrict: 'A',
      scope: {
        displayValue: '@',
        displayTime: '@',
        displayTitle: '@',
        displayDateFormat: '@',
        displayClass: '@',
        displayPosition: '@',
        template: '@'
      },
      link: link
    }

    function link($scope, element, attrs) {
      if (!element.scope().tooltipLoaded) {
        var attrsKeys = Object.keys(attrs)
        for (var i = 0; i < attrsKeys.length; i++) {
          var key = attrsKeys[i]
          if (key.substr(0, 'tooltipDisplay'.length) === 'tooltipDisplay') {
            var propertyName = key.substr('tooltipDisplay'.length)
            propertyName =
              propertyName.substr(0, 1).toLowerCase() + propertyName.substr(1)
            $scope[propertyName] = attrs[key]
          }
        }

        $scope.tooltipLoaded = true
        element.attr('uib-tooltip-template', $scope.template)
        element.attr('tooltip-placement', 'auto ' + $scope.displayPosition)
        element.attr('tooltip-append-to-body', 'true')
        element.attr('tooltip-class', $scope.displayClass)
        $compile(element)($scope)
      }
    }
  }
})()
